import angular from 'angular'
import './set_checklist.service'
angular
  .module('pub.set_checklist', ['pub.set_checklist.service'])
  .controller('SetChecklistsCtrl', SetChecklistsCtrl)

/** @ngInject */
function SetChecklistsCtrl($stateParams, SetChecklistsService) {
  var vm = this
  vm.items = []
  vm.perPage = 25
  vm.parentId = $stateParams.parentId

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    SetChecklistsService.list($stateParams.parentId, vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i]['ts-x']) {
          result.results[i]['ts-x'] = new Date(parseInt(result.results[i]['ts-x'] / 1000))
        }
        if (result.results[i]['ts-start']) {
          result.results[i]['ts-start'] = new Date(parseInt(result.results[i]['ts-start'] / 1000))
        }
        if (result.results[i]['ts-p']) {
          result.results[i]['ts-p'] = new Date(parseInt(result.results[i]['ts-p'] / 1000))
        }
      }

      vm.items = result.results
    })
  }

  load(1)

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }
}
